import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  extensionActivePage: "login",
};
export const sliceKey = "extensionActivePage";

export const extensionActivePageSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setExtensionActivePage: (state, { payload }) => {
      try {
        state.activePage = payload;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { setExtensionActivePage } = extensionActivePageSlice.actions;

export default extensionActivePageSlice.reducer;
